/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var lang_1 = require('../facade/lang');
var exceptions_1 = require('../facade/exceptions');
var intl_1 = require('../facade/intl');
var invalid_pipe_argument_exception_1 = require('./invalid_pipe_argument_exception');
var defaultLocale = 'en-US';
var _re = lang_1.RegExpWrapper.create('^(\\d+)?\\.((\\d+)(\\-(\\d+))?)?$');
var NumberPipe = (function() {
  function NumberPipe() {}
  NumberPipe._format = function(value, style, digits, currency, currencyAsSymbol) {
    if (currency === void 0) {
      currency = null;
    }
    if (currencyAsSymbol === void 0) {
      currencyAsSymbol = false;
    }
    if (lang_1.isBlank(value))
      return null;
    if (!lang_1.isNumber(value)) {
      throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(NumberPipe, value);
    }
    var minInt = 1,
        minFraction = 0,
        maxFraction = 3;
    if (lang_1.isPresent(digits)) {
      var parts = lang_1.RegExpWrapper.firstMatch(_re, digits);
      if (lang_1.isBlank(parts)) {
        throw new exceptions_1.BaseException(digits + " is not a valid digit info for number pipes");
      }
      if (lang_1.isPresent(parts[1])) {
        minInt = lang_1.NumberWrapper.parseIntAutoRadix(parts[1]);
      }
      if (lang_1.isPresent(parts[3])) {
        minFraction = lang_1.NumberWrapper.parseIntAutoRadix(parts[3]);
      }
      if (lang_1.isPresent(parts[5])) {
        maxFraction = lang_1.NumberWrapper.parseIntAutoRadix(parts[5]);
      }
    }
    return intl_1.NumberFormatter.format(value, defaultLocale, style, {
      minimumIntegerDigits: minInt,
      minimumFractionDigits: minFraction,
      maximumFractionDigits: maxFraction,
      currency: currency,
      currencyAsSymbol: currencyAsSymbol
    });
  };
  NumberPipe.decorators = [{type: core_1.Injectable}];
  return NumberPipe;
}());
exports.NumberPipe = NumberPipe;
var DecimalPipe = (function(_super) {
  __extends(DecimalPipe, _super);
  function DecimalPipe() {
    _super.apply(this, arguments);
  }
  DecimalPipe.prototype.transform = function(value, digits) {
    if (digits === void 0) {
      digits = null;
    }
    return NumberPipe._format(value, intl_1.NumberFormatStyle.Decimal, digits);
  };
  DecimalPipe.decorators = [{
    type: core_1.Pipe,
    args: [{name: 'number'}]
  }, {type: core_1.Injectable}];
  return DecimalPipe;
}(NumberPipe));
exports.DecimalPipe = DecimalPipe;
var PercentPipe = (function(_super) {
  __extends(PercentPipe, _super);
  function PercentPipe() {
    _super.apply(this, arguments);
  }
  PercentPipe.prototype.transform = function(value, digits) {
    if (digits === void 0) {
      digits = null;
    }
    return NumberPipe._format(value, intl_1.NumberFormatStyle.Percent, digits);
  };
  PercentPipe.decorators = [{
    type: core_1.Pipe,
    args: [{name: 'percent'}]
  }, {type: core_1.Injectable}];
  return PercentPipe;
}(NumberPipe));
exports.PercentPipe = PercentPipe;
var CurrencyPipe = (function(_super) {
  __extends(CurrencyPipe, _super);
  function CurrencyPipe() {
    _super.apply(this, arguments);
  }
  CurrencyPipe.prototype.transform = function(value, currencyCode, symbolDisplay, digits) {
    if (currencyCode === void 0) {
      currencyCode = 'USD';
    }
    if (symbolDisplay === void 0) {
      symbolDisplay = false;
    }
    if (digits === void 0) {
      digits = null;
    }
    return NumberPipe._format(value, intl_1.NumberFormatStyle.Currency, digits, currencyCode, symbolDisplay);
  };
  CurrencyPipe.decorators = [{
    type: core_1.Pipe,
    args: [{name: 'currency'}]
  }, {type: core_1.Injectable}];
  return CurrencyPipe;
}(NumberPipe));
exports.CurrencyPipe = CurrencyPipe;
